import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, finalize, timeout, } from 'rxjs/operators';
import { Client } from '../../models/Client';
import { AuthentictionService } from '../../services/authentiction.service';
import { Constant } from '../../services/data';
import { UtilService } from '../../services/util.service';
import { PlaylistService } from '../../services/playlist.service';
import { SeriesService } from '../../services/series.service';
import { MovieService } from '../../services/movie.service';
import { LivestreamService } from '../../services/livestream.service';
import { BsModalService, BsModalRef, ModalBackdropComponent } from 'ngx-bootstrap/modal';
import { LoadingDbModalComponent } from 'src/app/Shared/modal/dbloading-modal/dbloading-modal.component';


@Component({
  selector: 'app-server-login',
  templateUrl: './server-login.component.html',
  styleUrls: ['./server-login.component.css']
})
export class ServerLoginComponent implements OnInit ,AfterViewInit,OnDestroy {
  playListModal: any = {
    type: 'fromUrl',
    name: '',
    username: '',
    password: '',
    url: '',
    code:'',
    epg:'',
    pin:'',
    confirm_pin:'',
  };
  public activationCodes: any = {
    device_code:'',
    mac_type:'1',
    mac_address:'e43gwg44asdgasdgasdg',
    ip_address:'192.168.200.16',
    device_type:'web',
    platform:'web',
    app_name:'purple-web-player'
   };

  public isLoading: boolean = false;
  public serverList: any;
  public decodedata: any;
  inputValue:any
  public user: Client = {
    server: '',
    playlist:'',
    username: '',
    password: '',
    rememberMe: false,
  };
  public passwordTextType: boolean;
  codeValue:any;
  appMode:any;
  appConfig:any;
  isServerSelection:boolean= false;
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  playList: any = [];
  userid: any
  filterPlayList:any =[];
  isPlaylist:boolean = false;
  bsModalRef: BsModalRef;

    
  constructor(private router: Router, private modalService: BsModalService,private moviesService:MovieService,private livetvService:LivestreamService,private playlistService:PlaylistService, private authService: AuthentictionService, private utilService: UtilService, private changed: ChangeDetectorRef) {
  }
  
  ngOnInit(): void {
    this.codeValue = this.utilService.isLoginWithCode();
    console.log(this.codeValue);
    
    setTimeout(() => {
      this.loadBackgroundImg()
      
    }, 500);
    const UserData = JSON.parse(this.utilService.getFullUserId()) || '' ;
    console.log(UserData,'local storage');
    this.userid = UserData.user_id
    // this.playListModal.type = "onestreamUrl"
    if (this.userid) {
      console.log(this.userid,'onin');
      this.getPlayList();
    }else{

    }
  }
  
  ngAfterViewInit(): void {
    this.getServerList();
    this.fillForm();
    // this. loginWithCode()
  }

  getPlayList() {
    this.playList = [];
    let passModel: any = {
      userid: ''
    };
    
    passModel.userid = this.utilService.getFullUserId();

    this.utilService.showSpinner()
    this.isLoading = true;
    this.playlistService.getNewPlaylist().subscribe((res:any) =>{
      if(res.status === 'success'){
        console.log(res);
        this.playList = res.data
        this.filterPlayList = res.data
        this.isLoading = false;
        const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        this.filterPlayList = [...this.filterPlayList, ...localPlaylists];
        console.log(this.filterPlayList,'asdf');
        this.utilService.hideSpinner();
      }
    },err =>{
      this.isLoading = false;
      this.utilService.hideSpinner();
    })
  }

  checkDuplicateName(name) {
    let found = false;
    const inputName = name.toLowerCase();
    for (let index = 0; index < this.filterPlayList.length; index++) {
      const existingName = this.filterPlayList[index].playlist_name.toLowerCase();
      console.log(existingName,'exi');
      
      if (existingName === inputName) {
        found = true;
        this.utilService.showErrorToast('', 'Playlist name must be unique');
        break;
      }
    }
    return !found;
  }

  onSubmitold(form: NgForm) {
    console.log(this.user);
    
    if(form.valid && this.checkDuplicateName(this.user.playlist)){
      const urls = this.getSelectedServerUrl(this.user.server)
      let passModel: any = {
        type: 5,
        url: urls,
        playlist_name: this.user.playlist,
        username: this.user.username,
        password: this.user.password
      };      
      this.isLoading = true;
      this.utilService.showSpinner();

      //try server login 
       // If server selection is enabled, decode and use selected server
    if (this.appConfig?.server_selection !== 'false') {
      const url = this.getSelectedServerUrl(this.user.server);
      const passModel = {
        type: 5,
        url,
        playlist_name: this.user.playlist,
        username: this.user.username,
        password: this.user.password,
      };
      this.tryLoginWithUrl(passModel);
    } else {
      // Server selection is false, loop through all servers
      this.tryAllServers(0);
    }
    
      this.authService.validateXstreamGET(passModel.url, passModel.username, passModel.password).subscribe((res: any) => {
        if (res?.user_info) {
          this.handleValidXstream(passModel);
        } else {
          this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.password).subscribe((postRes: any) => {
            if (postRes?.user_info) {
              this.handleValidXstream(passModel);
            } else {
              this.isLoading = false;
              this.utilService.hideSpinner();
              this.utilService.showErrorCall('Invalid credentials from both GET and POST');
            }
          }, err => {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall(err);
          });
        }
      }, err => {
        this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.password).subscribe((postRes: any) => {
          if (postRes?.user_info) {
            this.utilService.saveAPImethod(Constant.APIMETHOD,'post'); // Optional utility method
            this.handleValidXstream(passModel);
          } else {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall('Invalid credentials from both GET and POST');
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner();
          this.utilService.showErrorCall(err);
        });
      
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorCall(err);
      });
    }
  }
  onSubmit(form: NgForm) {
  if (form.valid && this.checkDuplicateName(this.user.playlist)) {
    this.isLoading = true;
    this.utilService.showSpinner();

    // If server selection is enabled
    if (this.appConfig?.server_selection !== 'false') {
      const url = this.getSelectedServerUrl(this.user.server);
      const passModel = {
        type: 5,
        url,
        playlist_name: this.user.playlist,
        username: this.user.username,
        password: this.user.password,
      };

      this.authService.validateXstreamGET(passModel.url, passModel.username, passModel.password).subscribe((res: any) => {
        if (res?.user_info && res?.user_info?.auth == 1) {
          this.handleValidXstream(passModel);
        } else {
          this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.password).subscribe((postRes: any) => {
            if (postRes?.user_info?.auth == 1) {
              this.handleValidXstream(passModel);
            } else {
              this.loginFailed('Invalid credentials from both GET and POST');
            }
          }, err => this.loginFailed(err));
        }
      }, err => {
        this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.password).subscribe((postRes: any) => {
          if (postRes?.user_info && postRes?.user_info?.auth == 1) {
            this.utilService.saveAPImethod(Constant.APIMETHOD, 'post');
            this.handleValidXstream(passModel);
          } else {
            this.loginFailed('Invalid credentials from both GET and POST');
          }
        }, err => this.loginFailed(err));
      });

    } else {
      // If server selection is disabled, try all servers
      this.tryAllServers(0);
    }
  }
}


  tryLoginWithUrl(passModel: any) {
  this.authService.validateXstreamGET(passModel.url, passModel.username, passModel.password).subscribe((res: any) => {
    if (res?.user_info) {
      this.handleValidXstream(passModel);
    } else {
      this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.password).subscribe((postRes: any) => {
        if (postRes?.user_info) {
          this.handleValidXstream(passModel);
        } else {
          this.loginFailed();
        }
      }, err => this.loginFailed(err));
    }
  }, err => {
    this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.password).subscribe((postRes: any) => {
      if (postRes?.user_info) {
        this.utilService.saveAPImethod(Constant.APIMETHOD, 'post');
        this.handleValidXstream(passModel);
      } else {
        this.loginFailed();
      }
    }, err => this.loginFailed(err));
  });
}

tryAllServers(index: number) {
  if (!this.serverList || index >= this.serverList.length) {
    this.loginFailed('Invalid credentials.');
    return;
  }

  const currentServer = this.serverList[index];
  const passModel = {
    type: 5,
    url: currentServer.url,
    playlist_name: 'Purple Player',
    username: this.user.username,
    password: this.user.password,
  };

  this.authService.validateXstreamGET(passModel.url, passModel.username, passModel.password).subscribe((res: any) => {
    if (res?.user_info?.auth == 1) {
      this.handleValidXstream(passModel);
    } else {
      this.authService.validateXstreamPOST(passModel.url, passModel.username, passModel.password).subscribe((postRes: any) => {
        if (postRes?.user_info?.auth == 1) {
          this.utilService.saveAPImethod(Constant.APIMETHOD, 'post');
          this.handleValidXstream(passModel);
        } else {
          this.tryAllServers(index + 1); // Try next server
        }
      }, err => this.tryAllServers(index + 1));
    }
  }, err => this.tryAllServers(index + 1));
}
loginFailed(message: string = 'Invalid credentials') {
  this.isLoading = false;
  this.utilService.hideSpinner();
  this.utilService.showErrorCall(message);
}


  onActivate(form: NgForm) {
      if (form.invalid) {

        // Mark all controls as touched to show validation messages
        Object.keys(form.controls).forEach(field => {
          const control = form.controls[field];
          control.markAsTouched({ onlySelf: true });
        });
      return; // stop execution here if form is invalid
  }

  // Proceed with form submission if valid
  this.isLoading = false;
  this.utilService.hideSpinner();

  const param = {
    device_code: this.activationCodes.device_code,
    mac_type:this.activationCodes.mac_type,
    mac_address:this.activationCodes.mac_address,
    ip_address:this.activationCodes.ip_address,
    device_type:this.activationCodes.device_type,
    platform:this.activationCodes.platform,
    app_name:this.activationCodes.app_name
  }
  console.log(param);
  this.authService.activateCodeLogin(param).subscribe((res :any)=>{
   if(res.error){
   this.utilService.showErrorToast(res.error)
    
   }else if(res.success == true){
    localStorage.setItem('login_device',param.device_code)
    this.router.navigate(['/playlist'])
   }
  },err =>{
    console.log(err.error.error);
    
  })
  
}

//   loginWithCode(){
 
//     this.authService.loginWithCode('V0WSQ5')
//       .pipe(
//         timeout(UtilService.API_TIMEOUT),
//         finalize(() => {
//           this.isLoading = false;
//           this.utilService.hideSpinner()
//           this.changed.detectChanges();
//         })
//       )
//       .subscribe((res: any) => {
//         this.isLoading = false;
//         if (res.indexOf('{') === 0) {
//           const error = JSON.parse(res).error;
//           console.log(error);
//           if (error == 'App not found') {
//             this.utilService.showErrorInfo('', 'Access code is invalid.');
//           } else {
//             this.utilService.showErrorInfo('', error);
//           }
//         } else {
//           localStorage.setItem('code', this.user.code);
//           localStorage.setItem('Xtoken', res)
//           // this.router.navigate(['/server-login']);
//         }
//       }, err => {
//         this.isLoading = false;
//         this.utilService.hideSpinner()
//         this.utilService.showErrorInfo('', 'Authentication failed with server.');
//       });
// }

  encodeUrl(url: string): string {
    return btoa(url); // Base64 encoding
  }
  getSelectedServerUrl(url): string {
    const encodedUrl = url;
    if (encodedUrl) {
      return atob(encodedUrl); // Decode Base64
    }
    return ''; // or handle the case where the encodedUrl is not available
  }
  
  
  
  fillForm() {
    if (this.utilService.getValueCookie(Constant.ISREMEMBER_XKEY)) {
      this.user.username = this.utilService.getValueCookie(Constant.XSTREAMUSERNAME_KEY);
      this.user.password = this.utilService.getValueCookie(Constant.XSTREAMPASSWORD_KEY);
      this.user.server = this.utilService.getValueCookie(Constant.XSTREAMURL_KEY);
      this.changed.detectChanges();
    }
  }
  getServerList() {
    const decode1 = atob(localStorage.getItem('Xtoken'));
    const decode2 = atob(decode1);
    const decode3 = atob(decode2);
    const decode4 = atob(decode3);
    const data = JSON.parse(decode4);
    this.decodedata = data;
    this.appMode = data.app_mode;
    this.appConfig = data.app_conf;
    console.log(this.decodedata,'decodedata...');
    localStorage.setItem('logo',this.decodedata.app_image.app_logo)
    this.serverList = this.decodedata.app_dns;
  }
  loadBackgroundImg(){
      const el: any = document.querySelector('.auth-background');
      if (el) {
        el.style.background = `url('${this.decodedata.app_image.back_image}')`;
        // el.style.background = `url('/assets/images/new_icons/temp_bg.svg')`;

      }
  }


  onSubmits(form: NgForm) {
    if (form.valid) {
      this.isLoading = true;
      this.utilService.showSpinner()
      const urls = this.getSelectedServerUrl(this.user.server)
    
      this.authService.serverDnsLogin(urls,this.user.playlist, this.user.username, this.user.password)
        .subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
          //  this.getSelectedServerUrl()

          if (res.status == "success") {
             this.router.navigate(['/playlist'])
            if (res.user_info.auth) {
              this.utilService.removeFullModeStorage();
              // this.utilService.saveValueStorage(Constant.XSTREAMUSERID_KEY, res.user_info.userid);
              if (this.user.rememberMe) {
                this.utilService.clearCookieStorage();
                this.utilService.saveValueCookie(Constant.ISREMEMBER_XKEY, true);
                this.utilService.saveValueCookie(Constant.XSTREAMUSERNAME_KEY, this.user.username);
                this.utilService.saveValueCookie(Constant.XSTREAMPASSWORD_KEY, this.user.password);
                this.utilService.saveValueCookie(Constant.XSTREAMURL_KEY, urls);
              }
              else {
                this.utilService.clearCookieStorage();
              }
              this.utilService.saveValueStorage(Constant.XSTREAMUSERNAME_KEY, res.user_info.username);
              this.utilService.saveValueStorage(Constant.XSTREAMPASSWORD_KEY, res.user_info.password);
              this.utilService.saveValueStorage(Constant.XSTREAMURL_KEY, urls);

              if (this.decodedata.app_image.app_logo) {
                this.utilService.saveValueStorage(Constant.APP_LOGO, this.decodedata.app_image.app_logo);
              } else {
                this.utilService.removeLocalStorage(Constant.APP_LOGO);
              }

              if (this.decodedata.app_image.back_image) {
                this.utilService.saveValueStorage(Constant.APP_BACKGROUND, this.decodedata.app_image.back_image);
              } else {
                this.utilService.removeLocalStorage(Constant.APP_BACKGROUND);
              }

              this.router.navigate(['/home']);
              // this.router.navigate(['playlist'], { queryParams: { isRemember: this.user.rememberMe } });
              this.utilService.showErrorSuccess('', "Login Succesfully.");
            } else {
              this.utilService.showErrorInfo('', "Invalid credential.");

            }
          }
        }, err => {
          this.utilService.hideSpinner()
          this.isLoading = false;
          this.utilService.showErrorToast('', 'Incorrect username or password.');
        });
    }
  }

  handleValidXstream(passModel: any) {
    if (this.playList.length < 5 && this.userid) {
      console.log(passModel,'pass');
      this.playlistService.addNewXstreamPlaylist(passModel).subscribe((res: any) => {
        this.isLoading = false;
        this.utilService.hideSpinner();
        if (res.status === 'success') {
          this.utilService.showErrorSuccess('Xstream playlist is added successfully');
          this.getPlayList();
          this.router.navigate(['/playlist']);
          this.resetPlaylistModal();
          if (this.decodedata.app_image.app_logo) {
            this.utilService.saveValueStorage(Constant.APP_LOGO, this.decodedata.app_image.app_logo);
          } else {
            this.utilService.removeLocalStorage(Constant.APP_LOGO);
          }

          if (this.decodedata.app_image.back_image) {
            this.utilService.saveValueStorage(Constant.APP_BACKGROUND, this.decodedata.app_image.back_image);
          } else {
            this.utilService.removeLocalStorage(Constant.APP_BACKGROUND);
          }
        }
      }, err => {
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorCall(err);
      });
    } else {
      const fakeResponse = {
        status: 'success',
        message: 'Playlist added successfully',
        data: {
          user_id: this.userid,
          playlist_name: passModel.playlist_name,
          type: passModel.type,
          reseller_code: null,
          dns: passModel.url,
          username: passModel.username,
          password: passModel.password,
          epg: null,
          user_agent: null,
          updated_at: new Date().toISOString(),
          created_at: new Date().toISOString(),
          id: Date.now(),
          local: true,
          multiprofile:'true',
          appBackground:this.decodedata.app_image.back_image,
          appLogo:this.decodedata.app_image.app_logo
        }
      };
      console.log(fakeResponse);
      
  
      let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
      localPlaylists.push(fakeResponse.data);
      localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
      this.filterPlayList.push(fakeResponse.data);
      this.isLoading = false;
      this.utilService.hideSpinner();
      this.utilService.showErrorSuccess(fakeResponse.message);
      if(this.appConfig.multi_profile == 'false' && this.appMode == 'Xstream'){
        console.log(fakeResponse.data);
        this.loadData(fakeResponse.data);
      }else{
        this.router.navigate(['/playlist']);
      }
      this.resetPlaylistModal();
      if (this.decodedata.app_image.app_logo) {
        this.utilService.saveValueStorage(Constant.APP_LOGO, this.decodedata.app_image.app_logo);
      } else {
        this.utilService.removeLocalStorage(Constant.APP_LOGO);
      }

      if (this.decodedata.app_image.back_image) {
        this.utilService.saveValueStorage(Constant.APP_BACKGROUND, this.decodedata.app_image.back_image);
      } else {
        this.utilService.removeLocalStorage(Constant.APP_BACKGROUND);
      }
    }
  }
  
  resetPlaylistModal() {
    this.playListModal = {
      type: 'fromUrl',
      name: '',
      userName: '',
      password: '',
      url: ''
    };
  }

 loadData(data:any){
  console.log(data);
         localStorage.setItem('playlist',JSON.stringify(data));
  
     this.bsModalRef = this.modalService.show(LoadingDbModalComponent, {
              class: 'modal-fullscreen',
              initialState: {
                playlistItem: data // 👈 Corrected
              },
              ignoreBackdropClick: true,
              keyboard: false,
            });
    
            this.bsModalRef.content.onClose.subscribe((result: string) => {
              if (result === 'yes') {
                // All loaded successfully
                console.log('Loading complete');
                localStorage.setItem('isLocalPlaylist','true')
                localStorage.setItem('multiprofile','true')
                localStorage.setItem('playlist_id',data.id)
                localStorage.setItem('localProfile',JSON.stringify(data))

                // this.router.navigate(['/home'])
              } else {
                // Loading failed or was cancelled
                console.warn('Loading failed or cancelled');
              }
            });

  }
  

  hide(){
    const hideoption=document.getElementById('#visibles');
  }

  skip(){
 this.isPlaylist = this.authService.isPlayList();
 if(this.isPlaylist == true){
  this.router.navigate(['/playlist'])
 }else{
  this.router.navigate(['/add-playlist'])
 }
  }
  
  rememberMe(event: any) {
    this.user.rememberMe = event.target.checked;
  }
  changeCode() {
    localStorage.removeItem('Xtoken');
    localStorage.removeItem('code');
    this.router.navigate(['/code']);
  }
  preventSpace(event: any) {
    if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
      event.preventDefault();
    }
  }
  NumOnly(event: any) {
    let Numpattern = /^([0-9])*$/;
    let resultNum = Numpattern.test(event.key);
    return resultNum;

  }
  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Space') {
      event.preventDefault(); // Prevent the spacebar key from inserting a space
      this.inputValue = this.inputValue.replace(/\s/g, ''); // Remove all whitespace from the input value
    }
  }
  

  ngOnDestroy(): void {
    // localStorage.removeItem('code') 
    // localStorage.removeItem('Xtoken');

   }
}
